import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

import { NewSuggestionForm } from '@/features/feedback';
import { Icons } from '@/shared/ui';

import styles from './FeedbackPage.module.css';

export function NewSuggestionPage() {
  const { t } = useTranslation();
  return (
    <div className={styles.page}>
      <Link className={styles.back} to="/app/feedback">
        <Icons.back /> {t('feedback.detail.back')}
      </Link>
      <header>
        <h1 className={styles.title}>{t('feedback.new')}</h1>
        <p className={styles.lead}>{t('feedback.form.lead')}</p>
      </header>
      <NewSuggestionForm />
    </div>
  );
}
